var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDenied = function SvgDenied(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22 54-4.777 13.503L13 56l-1.12 12.241L6 62l2.518 16h20.72L22 54Z",
    fill: "#192C55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m53.193 78 1.647-3.276C57.518 69.398 62.945 66 68.775 66c3.303 0 6.476 1.097 9.03 3.122L89 78",
    fill: "#28BF9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m73.05 72-.1 6h-54l.1-6H24l4.5-14 17.969-3L63.5 58l4.18 13-.887.352L68 72h5.05-.001ZM59 44l-4.5-14-6.5-3-10.5 3L33 44l13.916 10L59 44Z",
    fill: "#FFD527"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5 30h-17L42 16h8l4.5 14ZM59 44H33l-4.5 14h35L59 44Z",
    fill: "#FCA760"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78v1H5v-1h86Zm-23.32-7H46v1h22l-.32-1Z",
    fill: "#192C55"
  })));
};
export default SvgDenied;